import { useTranslations } from "next-intl";
import Image from "@components/core/Image";
import Link from "@components/core/LinkApp";
import Button from "@components/core/Button";

function Custom404() {
  const t = useTranslations("common");

  return (
    <div
      style={{ padding: "96px 0" }}
      className="d-flex flex-column align-items-center"
    >
      <div
        style={{ width: "500px", maxWidth: "100%" }}
        className="px-4 text-center"
      >
        <Image
          src="closetLight"
          alt={t("not_found.img_alt")}
          className="w-100"
        />

        <div className="py-5">
          <h5 className="mb-0">{t("not_found.title")}</h5>
          <p className="mb-0">{t("not_found.subtitle")}</p>
        </div>

        <div>
          <Link href="/home">
            <Button hugContent>{t("not_found.back_to_home")}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Custom404;
